import { Component, OnInit, NgZone } from '@angular/core';
import {Location} from '@angular/common';
import * as _ from 'lodash';
import swal from 'sweetalert2';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { environment } from '@env/environment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';
import { Title } from '@angular/platform-browser';
declare var window: any; 
@Component({
  selector: 'app-purchase-tokens',
  templateUrl: './purchase-tokens.component.html',
  styleUrls: ['./purchase-tokens.component.css']
})
export class PurchaseTokensComponent implements OnInit {

  buyToken: number = 1;
  totalPrice: number = 250;
  tokenPrice: number = 0;
  tokenObject: any;
  loggedInStatus: any;
  userRole: any;
  hidePaymentBtn: boolean = false;
  stripePublicKey: string;
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    private rolesSharedService: RolesSharedService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private location: Location,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private titleService: Title
  ) {
   }

  ngOnInit() {
    this.getTokenPrice();
    this.isLoggedIn();
    this.initializeToken();
    this.stripePublicKey = environment.STRIPE_PUBLIC_KEY;
  }

  initializeToken() {
    const requiredTokens = this.route.snapshot.queryParamMap.get('required-tokens');
    this.buyToken = +requiredTokens;
    if (this.buyToken == 0) {
      this.buyToken = 1;
    }
  }
  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  goBack(){
    this.location.back();
  }
  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  getTokenPrice() {
    let dataObject: any = {};
    this.rolesSharedService.getTokenPrice().subscribe((response: any) => {
      dataObject = _.find(response, (data: any) => {
        return data.quantity === 1;
      });
      this.tokenPrice = dataObject.price;
      this.tokenObject = dataObject;
      this.totalPrice = this.buyToken * this.tokenPrice;
      if (this.totalPrice === 0) {
        this.totalPrice = 250;
      }
    });
  }

  addToken() {
    this.buyToken = this.buyToken + 1;
    this.totalPrice = this.buyToken * this.tokenPrice;
  }

  reduceToken() {
    if (this.buyToken > 1) {
      this.buyToken = this.buyToken - 1;
      this.totalPrice = this.buyToken * this.tokenPrice;
    }
  }
  onTokenChange(event) {
    this.totalPrice = this.buyToken * this.tokenPrice;
  }

  paymentGateway() {
    this.hidePaymentBtn = true;
    if (this.totalPrice > 0) {
      this.blockUI.start("Please wait...");
      var handler = (<any>window).StripeCheckout.configure({
        key: this.stripePublicKey,
        locale: 'auto',
        token: ((token: any) => {
          this.ngZone.run(() => {
            this.paymentCompleteAPI(token);
          });
        }),
        opened: () => {
          this.blockUI.stop();
        },
        closed: () => {
          this.hidePaymentBtn = false;
        }
      });
      handler.open({
        name: 'Payment',
        description: 'Enter details to proceed payment',
        amount: this.totalPrice * 100
      });
    }
  }

  paymentCompleteAPI(tokenData: any) {
    let tokenObject: any = {
      stripeToken: tokenData.id,
      quantity: this.buyToken
    }
    this.rolesSharedService.tokenPurchase(tokenObject).subscribe((purchaseTokenStatus: any) => {
      if (purchaseTokenStatus.statusCode == 200) {
        this.mixpanelEventLoggingService.dispatchEvent("token", {
          "No: of Token": this.buyToken,
          "Payment Mode": "Card"
        });
        this.totalPrice = 250;
        this.buyToken = 1;
        swal({
          position: "center",
          type: "success",
          title: "Done",
          showConfirmButton: false,
          timer: 2000
        });
        this.redirectToDetailsPage();

        this.titleService.setTitle('Token Purchased');
        var _hsq = window._hsq = window._hsq || [];
         _hsq.push(["trackEvent", {
          id: 'Token Purchased',
          value : 'Token Purchased'
          }]); 
        _hsq.push(['trackPageView'])
        _hsq.push(['refreshPageHandlers']); 
        

      } else {
        swal({
          position: "center",
          type: "error",
          title: purchaseTokenStatus.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    }, (error: any) => {
      this.hidePaymentBtn = false;
    });
  }

  redirectToDetailsPage() {
    const redirectDetails = this.route.snapshot.queryParamMap.get('redirect-details');
    const entityType = this.route.snapshot.queryParamMap.get('entity-type');
    if (entityType === 'report') {
      const reportId = this.route.snapshot.queryParamMap.get('report-details');
      this.hidePaymentBtn = false;
      if (reportId) {
        this.rolesSharedService.setPaymentSate(true);
        this.router.navigate([`${this.userRole}/report-details/${reportId}`]);
      }
    } else if (entityType === 'subscriptionPackage') {
      const reportSubscriptionPackageId = this.route.snapshot.queryParamMap.get('subscription-package-details');
    
      this.hidePaymentBtn = false;
      if (reportSubscriptionPackageId) {
        this.rolesSharedService.setPaymentSate(true);
      this.router.navigate([`package-subscription/package-details/${reportSubscriptionPackageId}`]);
      }
    } 
    else if (entityType === 'research') {
      const researchId = this.route.snapshot.queryParamMap.get('research-details');
      this.hidePaymentBtn = false;
      if (researchId) {
        this.rolesSharedService.setPaymentSate(true);
        if(this.userRole === 'tech-vendor') {
          this.router.navigate([`${this.userRole}/market-data/${researchId}`]);
        } else {
          this.router.navigate([`${this.userRole}/research-snapshot/${researchId}`]);
        }
      }
    } else if (redirectDetails) {
      this.location.back();
    } else {
      this.router.navigate([`${this.userRole}/my-profile`]);
    }
  }

  generateOrderBody() {
    let orderObject: any = []
    orderObject.push({
      packageId: this.tokenObject.id,
      amount: this.totalPrice,
      itemType: "token",
      quantity: this.buyToken
    })
    return orderObject;
  }

  numberValidate(event) {
    const length = event.target.form[0].value.length;
    if (event.which !== 8 && event.which !== 0 && event.which < 48 || event.which > 57 || length > 3) {
      event.preventDefault();
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/purchase-tokens/purchase-tokens.component.ts